import { ButtonSizes, StandardButton } from '@brandfolder/react';
import React from 'react';
import PropTypes from 'prop-types';

class TagsRow extends React.Component {
  state = {
    editMode: false,
    deleteMode: false,
    name: this.props.name
  }

  componentDidUpdate = (prevProps) => {
    if (this.props !== prevProps) {
      this.setState({
        name: this.props.name
      });
    }
  }

  toggleEditMode = () => {
    this.setState((prevState) => ({
      editMode: !prevState.editMode,
      deleteMode: !prevState.editMode ? false : prevState.deleteMode
    }));
  }

  toggleDeleteMode = () => {
    this.setState((prevState) => ({
      deleteMode: !prevState.deleteMode,
      editMode: !prevState.deleteMode ? false : prevState.editMode
    }));
  }

  updateName = (event) => {
    this.setState({ name: event.target.value });
  }

  renameTags = async () => {
    const { updateTags, name } = this.props;
    if (this.state.name && this.state.name !== name) {
      this.setState({
        isRenameLoading: true
      });
      await updateTags(name, this.state.name);
      this.setState({
        isRenameLoading: false
      });
      this.toggleEditMode();
    } else {
      Notify.create({
        title: bfTranslate('Please enter a name.'),
        type: 'error',
      });
    }
  }

  deleteTags = () => {
    const { updateTags, name } = this.props;
    updateTags(name, null);
  }

  showTag() {
    const { count } = this.props;
    return (
      <React.Fragment>
        <div className="show-tag-mode">
          <div className="tag-information">
            { this.renderTag() }
            <div className="fifteen-width">
              <p>{bfTranslate((count > 1) ? `${count}` : "1")}</p>
            </div>
          </div>
          <div className="button-container">
            <button
              className="button tertiary sm edit-tag"
              onClick={this.toggleEditMode}
              type="button"
            >
              {bfTranslate('Rename')}
            </button>
            <button
              className="delete-tag"
              onClick={this.toggleDeleteMode}
              onKeyUp={this.toggleDeleteMode}
              type="button"
            >
              <span className=" bff-trash" />
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderTag() {
    const { autoGenerated, name, ugtLocale } = this.props;
    let ugtLocaleParamString = '';
    if (BFG.locales?.ugtLocaleDefault && ugtLocale !== BFG.locales.ugtLocaleDefault) {
      ugtLocaleParamString = `&ugt_locale=${ugtLocale}`;
    }
    return (
      <div className="quarter-width">
        <a
          href={`/${BF.fx.brandfolder().slug}?q=tags.strict:"${encodeURIComponent(name)}"${ugtLocaleParamString}`}
        >
          <span className={`tag-name ${autoGenerated ? "auto-generated" : ""}`}>
            {name}
          </span>
        </a>
      </div>
    );
  }

  renderEdit() {
    const { name, count } = this.props;
    return (
      <div className="edit-tag-mode">
        <input
          className="bf-input bf-input--primary"
          defaultValue={name}
          id={`${name}-input`}
          onChange={this.updateName}
          type="text"
        />
        <div className="edit-buttons">
          <button
            className="button tertiary md cancel"
            onClick={this.toggleEditMode}
            type="button"
          >
            {bfTranslate('Cancel')}
          </button>
          <StandardButton
            loading={this.state.isRenameLoading}
            onClick={this.renameTags}
            size={ButtonSizes.Medium}
          >
            {count > 0
              ? bfTranslate('Rename tag')
              : `${bfTranslate('Rename')} ${count} ${bfTranslate('tags')}`}
          </StandardButton>
        </div>
      </div>
    );
  }

  renderDelete() {
    const { count } = this.props;
    return (
      <div className="delete-tag-mode">
        {this.renderTag()}
        <div className="delete-buttons">
          <button
            className="button tertiary md cancel"
            onClick={this.toggleDeleteMode}
            type="button"
          >
            {bfTranslate("Cancel")}
          </button>
          <button
            className="button warning md"
            onClick={this.deleteTags}
            type="button"
          >
            {(`${bfTranslate('Delete')} ${count} ${(count > 1) ? `${bfTranslate('Tags')}` : `${bfTranslate('Tag')}`}`)}
          </button>
        </div>
      </div>
    );
  }

  renderRow() {
    const { editMode, deleteMode } = this.state;
    if (editMode) { return this.renderEdit(); }
    if (deleteMode) { return this.renderDelete(); }
    return this.showTag();
  }

  render() {
    return this.renderRow();
  }
}

TagsRow.propTypes = {
  name: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  autoGenerated: PropTypes.bool.isRequired,
  ugtLocale: PropTypes.string.isRequired,
  updateTags: PropTypes.func.isRequired
};

export default TagsRow;
